import StoryCard from './StoryCard';

interface StoryRowProps {
  title: string;
  stories: any[];
  onStoryClick: (story: any) => void;
  onTagClick?: (tag: string) => void;
  badge?: string;
}

export default function StoryRow({ title, stories, onStoryClick, onTagClick, badge }: StoryRowProps) {
  if (!stories || stories.length === 0) return null;

  return (
    <section className="mb-10">
      <div className="flex items-center gap-3 mb-4">
        <h2 className="text-xl font-bold">{title}</h2>
        {badge && (
          <span className="px-2 py-0.5 bg-amber-500/20 text-amber-400 text-xs font-semibold rounded-full">
            {badge}
          </span>
        )}
      </div>
      <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-thin">
        {stories.map(story => (
          <div key={story.id} className="min-w-[160px] max-w-[160px] flex-shrink-0">
            <StoryCard story={story} onClick={() => onStoryClick(story)} onTagClick={onTagClick} />
          </div>
        ))}
      </div>
    </section>
  );
}
